import PropTypes from 'prop-types';
import React from 'react';
import { Box, Text, Button } from 'grommet';
import { FormClose } from 'grommet-icons';
import styled from 'styled-components';
const StyledBox = styled(Box)`
  ${({
  position
}) => {
  if (position === 'top-right' || position === 'bottom-right') return `
@-webkit-keyframes slideRight {
  0% {
    -webkit-transform: translateX(100%);
    -ms-transform: translateX(100%);
    transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slideRight {
  0% {
    -webkit-transform: translateX(100%);
    -ms-transform: translateX(100%);
    transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
}
animation: slideRight 0.2s ease-in-out forwards;
`;
  if (position === 'top') return `@-webkit-keyframes slideDown {
  0% {
    -webkit-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    transform: translateY(-100%);
  }
  100% {
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
}
@keyframes slideDown {
  0% {
    -webkit-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    transform: translateY(-100%);
  }
  100% {
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
}
animation: slideDown 0.2s ease-in-out forwards;`;
  if (position === 'bottom-left' || position === 'top-left') return `
@-webkit-keyframes slideLeft {
0% {
-webkit-transform: translateX(-100%);
-ms-transform: translateX(-100%);
transform: translateX(-100%);
}
100% {
-webkit-transform: translateX(0);
-ms-transform: translateX(0);
transform: translateX(0);
}
}
@keyframes slideLeft {
0% {
-webkit-transform: translateX(-100%);
-ms-transform: translateX(-100%);
transform: translateX(-100%);
}
100% {
-webkit-transform: translateX(0);
-ms-transform: translateX(0);
transform: translateX(0);
}
}
animation: slideLeft 0.2s ease-in-out forwards;
`;
  if (position === 'bottom') return `@-webkit-keyframes slideTop {
  0% {
    -webkit-transform: translateY(100%);
    -ms-transform: translateY(100%);
    transform: translateY(100%);
  }
  100% {
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
}
@keyframes slideTop {
  0% {
    -webkit-transform: translateY(100%);
    -ms-transform: translateY(100%);
    transform: translateY(100%);
  }
  100% {
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
}
animation: slideTop 0.2s ease-in-out forwards;`;
}}
`;
const Toast = ({
  text,
  background,
  redirect,
  styles,
  className,
  setToastData,
  uniqueId,
  themePosition,
  closeOnClick,
  showCloseBtn
}) => {
  const closeToast = e => {
    if (e) e.stopPropagation();
    setToastData(prev => {
      let newData = [...prev];
      newData = newData.filter(d => d.uniqueId !== uniqueId);
      return newData;
    });
  };
  const goToPage = () => {
    redirect();
    closeToast();
  };
  return /*#__PURE__*/React.createElement(StyledBox, {
    align: "center",
    round: "xsmall",
    elevation: "xsmall",
    pad: "small",
    background: {
      color: background ? background : 'status-ok',
      opacity: '0.9'
    },
    justify: "between",
    direction: "row",
    className: className,
    position: themePosition,
    onClick: redirect ? goToPage : closeOnClick ? closeToast : null,
    width: "320px",
    height: {
      min: '58px'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    flex: true,
    margin: {
      vertical: 'auto'
    },
    pad: {
      vertical: 'xsmall'
    },
    style: styles
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: 400,
    margin: {
      left: 'small'
    },
    textAlign: "center"
  }, text)), showCloseBtn && /*#__PURE__*/React.createElement(Button, {
    plain: true,
    icon: /*#__PURE__*/React.createElement(FormClose, {
      size: "20px"
    }),
    onClick: closeToast
  }));
};
Toast.defaultProps = {
  text: '',
  styles: null,
  background: null
};
Toast.propTypes = {
  text: PropTypes.string,
  background: PropTypes.string,
  index: PropTypes.number,
  redirect: PropTypes.func,
  styles: PropTypes.object,
  className: PropTypes.string,
  setToastData: PropTypes.func,
  uniqueId: PropTypes.any,
  themePosition: PropTypes.string,
  closeOnClick: PropTypes.bool,
  showCloseBtn: PropTypes.bool
};
export default Toast;